// extracted by mini-css-extract-plugin
export var address = "footerBottom-module--address--8d56d";
export var addressBox = "footerBottom-module--addressBox--2f522";
export var center = "footerBottom-module--center--b6aa0";
export var contactMail = "footerBottom-module--contactMail--06913";
export var contactNumber = "footerBottom-module--contactNumber--b2b96";
export var copy = "footerBottom-module--copy--65e0f";
export var current = "footerBottom-module--current--2ce42";
export var data = "footerBottom-module--data--cbf9f";
export var down = "footerBottom-module--down--99440";
export var footerLeft = "footerBottom-module--footerLeft--28c13";
export var footerRight = "footerBottom-module--footerRight--8ec97";
export var footerRightinner = "footerBottom-module--footerRightinner--158e9";
export var footer_add = "footerBottom-module--footer_add--d45ce";
export var footer_bottom = "footerBottom-module--footer_bottom--55063";
export var footer_col = "footerBottom-module--footer_col--463ba";
export var footer_nav = "footerBottom-module--footer_nav--55779";
export var footer_social = "footerBottom-module--footer_social--3bf51";
export var footer_title = "footerBottom-module--footer_title--0014e";
export var footer_wrapper = "footerBottom-module--footer_wrapper--9d508";
export var ft_col_inner = "footerBottom-module--ft_col_inner--96783";
export var india = "footerBottom-module--india--d8f2c";
export var inner_footer_bottom = "footerBottom-module--inner_footer_bottom--48c4f";
export var lines = "footerBottom-module--lines--c1989";
export var mapBox = "footerBottom-module--mapBox--1c25f";
export var round = "footerBottom-module--round--d378f";
export var roundDiv = "footerBottom-module--roundDiv--83ced";
export var subscribe_input_wrap = "footerBottom-module--subscribe_input_wrap--c1781";
export var subscribe_wrap = "footerBottom-module--subscribe_wrap--d5b97";
export var up = "footerBottom-module--up--5436f";
export var usa = "footerBottom-module--usa--c1db0";
export var usa2 = "footerBottom-module--usa2--5a871";
export var usa2Line = "footerBottom-module--usa2Line--0f00e";
export var usaLine = "footerBottom-module--usaLine--ba68e";